/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import React from "react";
import SectionThree from "./sectionthree";
import { Button, Table, Tabs, Radio } from "antd";
import axios from "axios";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

const { TabPane } = Tabs;
const columns = [
  {
    title: "Start Date",
    dataIndex: "start_date",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Emergency",
    dataIndex: "emergency",
  },
  {
    title: "Disaster Type",
    dataIndex: "dtypename",
  },
  {
    title: "Requested Amount",
    dataIndex: "amount_requested",
  },
  {
    title: "Funding (CHF)",
    dataIndex: "amount_funded",
  },
  {
    title: "Active",
    dataIndex: "statusname",
  },
];

const Sectiontwo = (props) => {
  let y = new Date();
  let y1 = y.getUTCFullYear();
  let m = y.getUTCMonth() + 1;
  let d = y.getDate();

  const url1 =
    "https://goadmin.ifrc.org/api/v2/appeal/?end_date__gt=" +
    y1 +
    "-" +
    m +
    "-" +
    d +
    "T08:28:12.707Z&limit=1000&country=194";
  const [post, setPost] = React.useState(null);
  const [, setUsers] = React.useState([]);
  const [idSum, setidSum] = React.useState([]);
  const [biSum, setbiSum] = React.useState([]);
  const [MulSum, setMulSum] = React.useState([]);
  const [pro, setPro] = React.useState([]);

  const data = [
    {
      name: "Bilateral",
      value: biSum,
    },
    {
      name: "Multilateral",
      value: MulSum,
    },
  ];
  let Ccount = 0;
  const fetchData = async () => {
    // debugger;
    const response = await fetch(
      "https://goadmin.ifrc.org/api/v2/project/?limit=500&country=MN"
    );
    const data = await response.json();
    let idSums = 0;
    let biSum = 0;
    let MulSum = 0;
    for (let i = 0; i < data.results.length; i++) {
      idSums += data.results[i].target_total;
      // eslint-disable-next-line eqeqeq
      
      data.results[i].programme_type_display == "Bilateral"
        ? biSum++
        : MulSum++;
      data.results[i].status_display == "Completed" ? Ccount++ : 0;
    }
    setUsers(data);
    setidSum(idSums);
    setbiSum(biSum);
    setMulSum(MulSum);
    setPro(Ccount);
    console.log(data);
    console.log(Ccount);
  };
  const data1 = [
    {
      name: "Completed",
      value: pro,
    },
  ];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(() => {
    axios.get(url1).then((response) => {
      for (var i = 0; i < response.data.results.length; i++) {
        response.data.results[i].start_date =
        response.data.results[i].start_date.substring(0,10);
        // eslint-disable-next-line no-unused-expressions
        response.data.results[i].dtypename =
          response.data.results[i].dtype.name;
        // eslint-disable-next-line eqeqeq
        // eslint-disable-next-line no-unused-expressions
        // eslint-disable-next-line eqeqeq
        response.data.results[i].statusname =
          response.data.results[i].status == 1 ? "Active" : "Closed";
      }
      setPost(response.data);
    });
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!post) return null;

  return (
    <>
      <section>
        <div className="container pt-20 pb-20">
          <div className="section-content">
            <div className="row">
              <div className="col-md-12">
                <div className="tabbable-panel">
                  <Tabs defaultActiveKey="1" centered type="card" size="large">
                    <TabPane tab="OPERATIONS" key="1">
                      <Table dataSource={post.results} columns={columns} />
                      <Button type="link" href="/appeals">
                        View All Operations For Mongolia
                      </Button>

                      <SectionThree />
                    </TabPane>
                    <TabPane tab="3W" key="2">
                      <div className="section-title text-center mt-0">
                        <div className="row pt-30">
                          <div className="col-md-8 col-md-offset-2">
                            <Radio.Group
                              defaultValue="a"
                              buttonStyle="solid"
                              size="large"
                            >
                              <Radio.Button value="a">
                                Projects in Mongolia
                              </Radio.Button>
                              <Radio.Button value="b">
                                Mongolian Red Cross Society Projects
                              </Radio.Button>
                            </Radio.Group>
                          </div>
                        </div>
                      </div>

                      <div className="section-content pt-30">
                        <div className="row">
                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="icon-box bg-white left media border-3px  mb-30 p-30 pb-20">
                              <div className="media-body">
                                <h2 className="font-weight-700 text-uppercase">
                                  0
                                </h2>
                                <p>Active National Societies</p>
                              </div>
                              <div className="media-body">
                                <h2 className="font-weight-700 text-uppercase">
                                  {idSum}
                                </h2>
                                <p>Targeted Population</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="icon-box bg-white left media border-3px  mb-30 p-30 pb-20">
                              <div className="media-body">
                                <h2 className="font-weight-700 text-uppercase">
                                  {post.count}
                                </h2>
                                <p>Total Projects</p>
                              </div>
                              <div className="media-body">
                                <PieChart width={120} height={120}>
                                  <Pie
                                    labelLine={true}
                                    data={data}
                                    isAnimationActive={false}
                                    cx={70}
                                    cy={50}
                                    dataKey="value"
                                    outerRadius={40}
                                    fill={"#ED1C24"}
                                    label={data.name}
                                  />
                                  <Tooltip />
                                </PieChart>
                              </div>
                              <div className="media-body">
                                <h5 className="font-weight-700 text-uppercase">
                                  Programme Type
                                </h5>
                                <ul>
                                  <li>Bilateral</li>
                                  <li>Multilateral</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="col-xs-12 col-sm-6 col-md-4">
                            <div className="icon-box bg-white left media border-3px  mb-30 p-30 pb-20">
                              <div className="media-body pr-10">
                                <h2 className="font-weight-700 text-uppercase">
                                  0
                                </h2>
                                <div className="media-content">
                                  <p>Total Budget (CHF) for Ongoing Projects</p>
                                </div>
                              </div>
                              <div className="media-body">
                                <PieChart width={120} height={120}>
                                  <Pie
                                    labelLine={true}
                                    data={data1}
                                    isAnimationActive={false}
                                    cx={70}
                                    cy={50}
                                    dataKey="value"
                                    outerRadius={40}
                                    fill={"#ED1C24"}
                                    label={data.name}
                                  />
                                  <Tooltip />
                                </PieChart>
                              </div>
                              <div className="media-body">
                                <h5 className="font-weight-700 text-uppercase">
                                  Project status
                                </h5>
                                <ul>
                                  <li>Completed</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sectiontwo;
